import { getDefaultTimeStamp } from "./util";


export const BASE_URL = `https://api.${process.env.REACT_APP_LAMBDA_ENV}.${process.env.REACT_APP_PROJECT_NAME}.cognien.abb/dashboard/`;

export const BASE_URL_MFA = `https://${process.env.REACT_APP_AWS_COGNITO_MFA_URL}.auth.${process.env.REACT_APP_AWS_COGNITO_REGION}.amazoncognito.com/mfa?client_id=${process.env.REACT_APP_AWS_COGNITO_CLIENT_ID}&response_type=code&scope=email+openid+profile&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_AWS_COGNITO_MFA_ENV}.demo.cognien.abb%2F`;

// Widget names for dashboard cards
export const WIDGET_NAMES = [
  { key: 'energy_generation', label: 'ENERGY GENERATION (MWh)' },
  { key: 'water_consumption', label: 'WATER CONSUMPTION (m³)' },
  { key: 'energy_consumption', label: 'ENERGY CONSUMPTION (MWh)' },
  { key: 'gas_consumption', label: 'GAS CONSUMPTION (m³)' },
];

//cybershield
const defaultTS = getDefaultTimeStamp();
const startTS = defaultTS.startDate;
const endTS = defaultTS.endDate;


export const ERROR_LIST = {
  ERROR_FETCH_DATA: `There was a problem fetching the data`,
  ERROR_FILE_NOT_UPLOADED: `There is no data available`,
  ALARM_SUMMARY_EMPTY_DATA: `There are no alarms to display at this time.`,
  NO_EVENTS: `There are no events available at this time.`,
  NO_RECORDS: `There are no records available at this time.`,
  NO_DATA: `There is no data available at this time.`,

};
export const MESSAGES = {
  SIGN_IN_TRIGGER: "Verifying Credentials, Please Wait...",
  SIGN_IN_TIME_OUT_TRIGGER: "",
  POST_SIGN_WAITING: "Waiting for User Mail Verification",
  MFA_QR_CODE_PREFIX: "otpauth://totp/bedas-dev.auth.eu-central-1.amazoncognito.com:",
  MFA_EMAIL_ABB_LOGO_URL: "https://qr-code-storage-test.s3.eu-central-1.amazonaws.com/Logo.png",
  MFA_QR_CODE_SECRET_PREFIX: "?secret=",
  MFA_EMAIL_SENDER: "cognien.abb.noreply@gmail.com",
  MFA_EMAIL_SUBJECT: "Secure your CogniEn account with Two-Factor Authentication",
  MFA_EMAIL_TITLE: "Follow these steps to set up two-factor authentication:",
  MFA_INSTRUCTIONS_STEP_1: "1. Install an authenticator app on your mobile device",
  MFA_INSTRUCTIONS_STEP_2: "2. Scan this QR code with your authenticator app. ",
  MFA_INSTRUCTIONS_ALTERNATIVE_STEP: "Alternatively, you can manually enter a secret key in your authenticator app. ",
  MFA_INSTRUCTIONS_ALTERNATIVE_STEP_FOR_EMAIL: "If you want to manually enter a secret key in your authenticator app, the secret key is: ",
  FORGOT_PASSWORD_TITLE: "Password Change Successful",
  FORGOT_PASSWORD_BODY: "Your password has been changed successfully. Please login with your new password.",
  CONFIRM_USER_TITLE: "Confirm User Details",
  CONFIRM_USER_BODY: "Are you sure you want to save user details?",
  CONFIRMED_USER_TITLE: "Updated User Details",
  CONFIRMED_USER_BODY: "User Details updated successfully. The updates will be reflected in the next login",
  SUBSTATION_AREAS_LOAD_MESSAGE: "Please wait while we fetch the substations from the assigned operation areas",
  SUBSTATION_LOADING: "Loading substations...",
  POST_SIGN_UP_TRIGGER:
    "Thank you for creating an account with CogniEN.\n An email has been sent to your registered email. Please verify it to obtain approval from the administrators",
  IN_SIGNUP_TRIGGER: "Submitting Request..."
}



// ========== CONSTANTS: ROLES ==========
export {
  SUBSTATION_ROLES,
} from "./constants/roles";
